import script from "./WorkspaceUsers.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkspaceUsers.vue?vue&type=script&setup=true&lang=js"

import "./WorkspaceUsers.vue?vue&type=style&index=0&id=664335f6&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-664335f6"]])

export default __exports__